<template>
    <div class="wscn-http500-container">
        <img src="../../assets/image/ts5001.png" alt="">
    </div>
</template>

<script>

    export default {
        name: 'Page500',
        computed: {
            message() {
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    body{background: #f2f5f6 !important;}
    .wscn-http500-container{width: 1200px;margin: 200px auto;    background: #fff !important;}
</style>
